'use strict';

var GetIntrinsic = require('get-intrinsic');

var originalGetProto = GetIntrinsic('%Object.getPrototypeOf%', true);
var $ArrayProto = GetIntrinsic('%Array.prototype%');

module.exports = originalGetProto || (
	// eslint-disable-next-line no-proto
	[].__proto__ === $ArrayProto
		? function (O) {
			return O.__proto__; // eslint-disable-line no-proto
		}
		: null
);



//////////////////
// WEBPACK FOOTER
// ./~/es-abstract/helpers/getProto.js
// module id = 1353
// module chunks = 0